import type { SelfServiceAPI } from 'types';
import type { Options } from '../types';
import api from 'lib/axios/api';
import handleServiceError from '../utils/handleServiceError';

interface Params {
  bookingId: string;
  amendmentId: string;
}

const getAmendment = async ({ bookingId, amendmentId }: Params, options: Options = {}): Promise<SelfServiceAPI.GetAmendment.Response> => {
  try {
    const { data } = await api.get(`/bookings/${bookingId}/amendments/${amendmentId}`);
    return data;
  } catch (error) {
    handleServiceError(error, {
      operationName: `GET /bookings/${bookingId}/amendments/${amendmentId}`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default getAmendment;
